require("-!/home/lucas/proyectos/modulo-pagos/checkout-manager/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!style-loader!css-loader?sourceMap!less-loader?sourceMap!/home/lucas/proyectos/modulo-pagos/checkout-manager/node_modules/font-awesome-webpack/font-awesome-styles.loader.js!/home/lucas/proyectos/modulo-pagos/checkout-manager/utils/font-awesome/font-awesome.config.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/font-awesome-webpack/index.loader.js!./utils/font-awesome/font-awesome.config.js
// module id = 873
// module chunks = 0